<template>
    <div class="adSets table-body" v-if="hasLoaded">
        <facebook-ads-table-row v-for="adSet in adSets"
                                type="adSet"
                                :status="status"
                                :ad-set="adSet"
                                :key="adSet.id"/>
    </div>
</template>


<script>
  import FacebookAdsTableRow from '@/app/facebook/components/ads/FacebookAdsTableRow'
  import { mapGetters } from 'vuex'
  import datepickerMixin from '@/app/datepicker/datepicker.mixin'

  export default {
    mixins: [datepickerMixin],
    data () {
      return {
        adSets: [],
        selectedAdSet: null,
        hasLoaded: false
      }
    },

    props: {
      status: {
        type: String,
        default: 'ACTIVE'
      }
    },

    watch: {
      metrics: {
        handler: 'load',
        immediate: true
      }
    },

    computed: mapGetters('facebookAds', { metrics: 'getMetrics' }),

    methods: {
      async load () {
        this.$emit('hasLoaded', false)
        this.hasLoaded = false
        this.adSets = await this.$store.dispatch('facebookAds/loadAdSets', this.status)
        this.hasLoaded = true
        this.$emit('hasLoaded', true)
      },

      select (adSet) {
        this.$emit('select', adSet)
      }
    },

    components: {
      FacebookAdsTableRow
    }
  }
</script>
